import { BaseComponent } from '../base-component'
import { parseHTML } from '../../utils/dom'
import { PaginationComponent } from './pagination'
import { $el, $elParent } from 'src/scripts/utils/utils'

const PRELOADER_SELECTOR = '.loading-spinner'
const INTERSECTION_OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '0px 0px 200px 0px',
}

export class PaginationInfiniteScroll extends BaseComponent {
  intersectionObserver: IntersectionObserver

  mountComponent(): void {
    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersectionObserve,
      INTERSECTION_OBSERVER_OPTIONS,
    )
    this.intersectionObserver.observe(this)
  }

  unmountComponent(): void {
    this.intersectionObserver.disconnect()
  }

  handleIntersectionObserve = (entries: IntersectionObserverEntry[]): void => {
    const preloader = $el(PRELOADER_SELECTOR, this)
    const url = this.dataset.url

    if (url) {
      if (!entries[0].isIntersecting) {
        return
      }

      this.intersectionObserver.unobserve(this)

      preloader.classList.remove('hidden')

      fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const html = parseHTML(responseText)
          const pagination: PaginationComponent = $elParent(
            'pagination-component',
            this,
          )

          preloader.classList.add('hidden')
          this.updateFromHTML(html)

          if (pagination) {
            pagination.updateTargetsFromHTML(html)
          }
        })
        .catch(() => {
          console.log('Error in infinite scroll component')
        })
    }
  }

  updateFromHTML(html: Document): void {
    const newPagination: PaginationInfiniteScroll = $el(
      'pagination-infinite-scroll',
      html,
    )

    if (newPagination) {
      this.setPaginationUrl(newPagination.dataset.url)
      this.intersectionObserver.observe(this)
    } else {
      this.removeAttribute('data-url')
    }
  }

  setPaginationUrl(url: string): void {
    this.dataset.url = url
  }
}
